<template>
    <div class="call-task-manage-second">
        <el-button type="primary" size="mini" icon="el-icon-back" @click="$router.back()">返回上一级</el-button>
        <el-divider content-position="left">外部资源外呼任务管理-子页面</el-divider>
        <div class="cal-tas-search-con">
            <!-- <div>
                <!== <select-input :options="first_cate_options" value="source" label="label" placeholder="请选择分类"
                    controller="\App\Controller\Qyh\CallTaskController" method="list" :host="hyperfHost"
                    @createSearch="createSearch" /> ==>
            </div>
            <div style="margin-left: auto; display: flex; justify-content:space-evenly;gap: 0.2rem;">
                <el-button type="primary" size="mini" @click="$router.push('ct_cate_manage')">分类管理</el-button>
                <!== <el-button type="primary" size="mini" @click="openDistributeDialog">分配资源</el-button> ==>
                <!== <import class="cal-tas-im-cla" data="\App\Http\Controllers\Admin\CommonController::handleCallTask">
                    <template v-slot:name>
                        导 入
                    </template>
</import> ==>
<el-button type="primary" size="mini" @click="dialog_import = true">开始导入</el-button>
<el-button type="primary" size="mini" @click="refreshPhoneInfoAll">刷新手机号信息</el-button>
</div> -->
        </div>

        <div class="call-task">
            <!-- <count-cate class="count-con" v-for="(item, index) in tableData" :key="index">
                <template v-slot:body>
                    <span class="c-title">{{ item.call_cate.first_level }}</span>
                    <span>
                        <span>
                            总数
                        </span>
                        <span>
                            {{ item.not_assign + item.assigned }}
                        </span>
                    </span>
                    <span class="c-c-assigned">
                        <span>
                            已分配
                        </span>
                        <span>
                            {{ item.assigned }}
                        </span>
                    </span>
                    <span class="c-c-not-assign">
                        <span>
                            未分配
                        </span>
                        <span>
                            {{ item.not_assign }}
                        </span>
                    </span>
                </template>
            </count-cate> -->
            <!-- <div style="display: flex;gap: 0.2rem;flex-wrap: wrap;"> -->
            <div style="column-count: 3;column-gap: 8px;">
                <!-- <el-tooltip effect="dark" content="点击查看子分类" placement="top" v-for="(item, index) in tableData" :key="index"> -->
                <el-card v-for="(item, index) in tableData" :key="index" shadow="always" class="box-card-my">
                    <div slot="header" class="clearfix">
                        <span class="box-card-title">{{ item.call_cate.name }}</span>
                        <el-button style="float: right; padding: 3px 0" type="text"
                            @click="openDistributeDialog(item.call_cate.pid)">分配资源</el-button>
                    </div>
                    <table class="field-table" border>
                        <tr>
                            <td>
                                <span class="first-td">分配情况:</span>
                            </td>
                            <td>
                                <el-tag class="table-dis" size="mini" type="primary" effect="dark">
                                    <span>
                                        总数
                                    </span>
                                    <span>
                                        {{ item.not_assign + item.assigned }}
                                    </span>
                                </el-tag>
                            </td>
                            <td>
                                <el-tag class="table-dis" size="mini" type="success" effect="dark">
                                    <span>
                                        已分配
                                    </span>
                                    <span>
                                        {{ item.assigned }}
                                    </span>
                                </el-tag>
                            </td>
                            <td>
                                <el-tag class="table-dis" size="mini" type="danger" effect="dark">
                                    <span>
                                        未分配
                                    </span>
                                    <span>
                                        {{ item.not_assign }}
                                    </span>
                                </el-tag>
                            </td>
                        </tr>
                    </table>
                </el-card>
                <!-- </el-tooltip> -->
            </div>
        </div>

        <el-dialog :visible.sync="dialog" @closeDialog="closeDialog" @beforeCloseDialog="beforeCloseDialog" width="50%"
            center>
            <template v-slot:title>
                <span class="cal-tas-m-dia-title">
                    分配资源
                </span>
            </template>
            <div class="cal-tas-m-bg-con">
                <button-group :buttonGroup="1" :options="buttonGroupOptions" @buttonGroupChange="buttonGroupChange" />
                <div v-if="distribute.dis_type === 1">
                    <el-card shadow="hover" class="box-card">
                        <div slot="header" class="clearfix">
                            <span>选择人员</span>
                        </div>
                        <div class="text item">
                            <checkbox-com ref="checkboxCom" :options="callerOptions" label="username"></checkbox-com>
                        </div>
                    </el-card>
                    <el-card shadow="hover" class="box-card">
                        <div slot="header" class="clearfix">
                            <span>每人分配条数</span>
                        </div>
                        <div class="text item">
                            <el-form :model="distribute" ref="distribute" label-width="0px" class="demo-dynamic">
                                <el-form-item prop="avgNum" label="" :rules="[
            { required: true, message: '请输入每人分配条数', trigger: 'blur' },
            { min: 1, message: '请输入正确的每人分配条数', trigger: 'blur' },
        ]">
                                    <el-input type="number" clearable v-model="distribute.avgNum"
                                        size="mini"></el-input>
                                </el-form-item>
                            </el-form>
                        </div>
                    </el-card>
                </div>
                <div v-else-if="distribute.dis_type === 2" style="margin-top: 0.2rem;">
                    <checkbox-input ref="checkboxInput" :options="callerOptions" label="username" />
                </div>
                <div style="display: flex;margin-top: 0.2rem">
                    <div style="margin-left: auto;">
                        <el-button type="primary" @click.native="submitForm('distribute')" size="mini">提交</el-button>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import ButtonGroup from '../../commonReform/ButtonGroup';
import CheckboxCom from '../../commonReform/CheckboxCom';
import CheckboxInput from '../../commonReform/CheckboxInput';
export default {
    name: 'CallTaskManageSecond',
    components: { ButtonGroup, CheckboxCom, CheckboxInput },
    data() {
        return {
            hyperfHost:
                process.env.NODE_ENV === "development"
                    ? "http://127.0.0.1:9501/v1/"
                    : "https://qyh-next-server.zhang66.cn/v1/",
            tableData: [],
            dialog: false,
            buttonGroupOptions: [
                {
                    label: '平均分配',
                    value: 1
                },
                {
                    label: '自定义分配',
                    value: 2
                },
            ],
            distribute: {
                dis_type: 1,
                avgNum: null
            },
            callerOptions: [],
            cateId: '',
        }
    },
    methods: {
        loadTable() {
            this.$axios.get(`${this.hyperfHost}api/call_task/second_list`, {
                loadingClose: true,
                params: {
                    search: this.search,
                    id: this.$route.params.id
                }
            }).then(({ data }) => {
                if (data.code === 0) {
                    this.tableData = data.data
                }
            }).catch()
        },
        openDistributeDialog(id) {
            this.cateId = id
            this.loadCaller()
            this.dialog = true
        },
        loadCaller() {
            this.$axios.get('/api/api3_call_task/get_caller', {
                loadingClose: true
            }).then(({ data }) => {
                if (data.code === 0) {
                    this.callerOptions = data.data
                }
            }).catch()
        },
        closeDialog() {
            this.cateId = ''
        },
        beforeCloseDialog() {

        },
        buttonGroupChange(val) {
            this.distribute.dis_type = val
        },
        submitForm(formName) {
            this.distribute.cateId = this.cateId
            if (this.distribute.dis_type === 1) {
                this.distribute.checkBoxCom = this.$refs.checkboxCom.checkList
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        this.$axios
                            .post('/api/api3_call_task/distribute', this.distribute)
                            .then(res => {
                                const { data } = res
                                if (data.code === 0) {
                                    this.$message.success(data.msg)
                                    this.loadTable()
                                    this.dialog = false
                                } else {
                                    this.$message.error(data.msg)
                                }
                            })
                    } else {
                        return false
                    }
                })
            } else if (this.distribute.dis_type === 2) {
                this.distribute.checkboxInput = this.$refs.checkboxInput.avgNum
                this.$axios
                    .post('/api/api3_call_task/distribute', this.distribute)
                    .then(res => {
                        const { data } = res
                        if (data.code === 0) {
                            this.$message.success(data.msg)
                            this.loadTable()
                            this.dialog = false
                        } else {
                            this.$message.error(data.msg)
                        }
                    })
            } else {
                return false
            }
        },
    },
    mounted() {
        this.loadTable()
    }
}
</script>

<style scoped>
.call-task-manage-second {
    padding: 1.82rem 0.4rem 0.4rem 0.4rem;
}

.call-task-manage-second .cal-tas-search-con {
    display: flex;
    align-items: center;
}

.call-task-manage-second .call-task {
    display: flex;
    background-color: #F2F6FC;
    padding: 0.3rem;
    min-height: calc(100vh - 5.2rem);
    margin-top: 0.2rem;
    justify-content: space-evenly;
}

.call-task-manage-second .box-card-my {
    width: 9rem;
    height: fit-content;
}

/* 表格 */
.call-task-manage-second .field-table {
    border: 1px solid #eeeaea;
}

.call-task-manage-second .centered {
    /* 水平居中 */
    text-align: center;
    /* 垂直居中 */
    vertical-align: middle;
}

.call-task-manage-second .field-table td {
    padding: 0.1rem 0.15rem;
    box-sizing: border-box;
}

.call-task-manage-second .centered-count {
    text-align: right;
}

/* 表格end */
.call-task-manage-second .table-dis {
    /* cursor: pointer; */
    font-size: small;
}

.call-task-manage-second .first-td {
    white-space: nowrap;
}

.call-task-manage-second .box-card-title {
    font-size: large;
    font-weight: bold;
}
.call-task-manage-second .cal-tas-m-dia-title {
    font-size: large;
    font-weight: bold;
    color: #409EFF;
}
.call-task-manage-second .cal-tas-m-bg-con {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
}
.call-task-manage-second .box-card {
    margin-top: 0.2rem;
    width: 480px;
}
.call-task-manage-second .call-task-manage>>>.el-dialog {
    display: flex;
    flex-direction: column;
    margin: 0 !important;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    /*height:600px;*/
    max-height: calc(100% - 200px);
    max-width: calc(100% - 30px);
    box-shadow: 0 15px 30px rgba(0, 0, 0, .3);
}

.call-task-manage-second .clearfix:before,
.call-task-manage-second .clearfix:after {
    display: table;
    content: "";
}

.call-task-manage-second .clearfix:after {
    clear: both
}
</style>


// WEBPACK FOOTER //
// src/pages/cloudClue/CallTaskManageSecond.vue